/* eslint-disable max-len */
const availableGlitches = []
module.exports = availableGlitches
